import Navbar from "../components/Navbar";
import {
  AiOutlineHeart,
  AiFillStar,
  AiOutlineStar,
  AiOutlineLeft,
  AiOutlineRight,
} from "react-icons/ai";
import { Tabs } from "@mantine/core";
import ReviewCard from "../components/ReviewCard";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Navigation,
  Pagination,
  Keyboard,
  Mousewheel,
  FreeMode,
} from "swiper/modules";
import ProductCard from "../components/ProductCard";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "../Styles/ProductDetails.css";
import { useEffect, useState } from "react";
import ServiceCard from "../components/ServiceCard";
import Footer from "../components/Footer";
import axios from "axios";
import { url } from "../db/url";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";

const ProductDetails = () => {
  const [quantity, setQuantity] = useState(1);
  const parts = window.location.href.split("/");
  const id = parts[parts.length - 1];
  const [product, setProduct] = useState({});
  const [products, setProducts] = useState([]);
//   const { cart } = useSelector((state) => state.cart);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const changeQuantity = (value) => {
    if (value === "reduce") {
      quantity === 0 ? setQuantity(0) : setQuantity(quantity - 1);
    } else if (value === "add") {
      setQuantity(quantity + 1);
    }
  };

  useEffect(() => {
    axios
      .get(`${url}/api/v2/product/single-product/${id}`)
      .then((res) => {
        console.log(res.data);
        setProduct(res.data.product[0]);
        filteredData(res.data.product[0].category);
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.response ? err.response.data.message : "Network Error");
      });
  }, []);

  const rating = (num) => {
    const rate = Math.round(num) || 0;
    return rate === 5 ? (
      <div className="rating">
        <AiFillStar />
        <AiFillStar />
        <AiFillStar />
        <AiFillStar />
        <AiFillStar />
      </div>
    ) : rate === 4 ? (
      <div className="rating">
        <AiFillStar />
        <AiFillStar />
        <AiFillStar />
        <AiFillStar />
        <AiOutlineStar />
      </div>
    ) : rate === 3 ? (
      <div className="rating">
        <AiFillStar />
        <AiFillStar />
        <AiFillStar />
        <AiOutlineStar />
        <AiOutlineStar />
      </div>
    ) : rate === 2 ? (
      <div className="rating">
        <AiFillStar />
        <AiFillStar />
        <AiOutlineStar />
        <AiOutlineStar />
        <AiOutlineStar />
      </div>
    ) : (
      <div className="rating">
        <AiFillStar />
        <AiOutlineStar />
        <AiOutlineStar />
        <AiOutlineStar />
        <AiOutlineStar />
      </div>
    );
  };

  const addToCart = () => {
    if(!Cookies.get('TOKEN')){
      toast.error('Please login first')
      return
    }
    let cart = localStorage.getItem('cart');
    if (!cart) {
        cart = [];
      } else {
        // Parse the existing cart from a JSON string
        cart = JSON.parse(cart);
      }
      const existingProduct = cart.find(item => item.id === product.id);

        if (existingProduct) {
            toast.error("Item already exists in cart")
            return
        } else {
        // If the product doesn't exist in the cart, add it
        cart.push({...product, qty: quantity});
        }
        localStorage.setItem('cart', JSON.stringify(cart));
        toast.success("Item added to cart successfully")
  }
  const addToWishlist = () => {
      if(!Cookies.get('TOKEN')){
      toast.error('Please login first')
      return
      }
      let wishlist = localStorage.getItem('wishlist');
      if (!wishlist) {
          wishlist = [];
      } else {
          // Parse the existing cart from a JSON string
          wishlist = JSON.parse(wishlist);
      }
      const existingProduct = wishlist.find(item => item.id === product.id);

      if (existingProduct) {
          toast.error("Item already exists in Wishlist")
          return
      } else {
      // If the product doesn't exist in the cart, add it
      wishlist.push({...product});
      }
      localStorage.setItem('wishlist', JSON.stringify(wishlist));
      toast.success("Item added to wishlist successfully")
  }

  function filteredData(selected) {
    axios
      .get(`${url}/api/v2/product/get-all-products`)
      .then((res) => {
        console.log(res.data.products);
        setProducts(res.data.products.filter((el) => el.category === selected));
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.response ? err.response.data.message : "Network Error");
      });
  }

  return (
    <>
      <Navbar />

      <section className="detailWrapper">
        <div className="leftDetail">
          <img src={product.images && product.images[0].url} alt="" />
          <div className="smallImages">
            {product.images &&
              product.images.map((el) => {
                return <img src={el.url} alt="" />;
              })}
          </div>
        </div>
        <div className="rightDetail">
          <div className="detailHeading">
            <h2>{product.name}</h2>
            <div className="priceWrap">
              <p>${product.discountPrice}</p>
              <div className="rating">{rating(product.ratings)}</div>
            </div>
          </div>
          <hr />
          <p className="description">{product.description}</p>
          <hr />
          <div className="buttonWrap">
            <div className="count">
              <p className="reduce" onClick={() => changeQuantity("reduce")}>
                -
              </p>
              <p>{quantity}</p>
              <p className="add" onClick={() => changeQuantity("add")}>
                +
              </p>
            </div>
            <button onClick={() => addToCart()}>
              Add to Cart
            </button>
            <AiOutlineHeart onClick={addToWishlist}/>
          </div>
          <hr />
          <div className="detailCategoryWrapper">
            <p>
              <span>Category:</span> {product.category}
            </p>
          </div>
        </div>
      </section>

      <section className="tabs">
        <Tabs color="green" defaultValue="description">
          <Tabs.List>
            <Tabs.Tab value="description">Description</Tabs.Tab>
            <Tabs.Tab value="info">Additional Info</Tabs.Tab>
            <Tabs.Tab value="reviews">
              Reviews({product.reviews && product.reviews.length})
            </Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="description" pt="xs">
            <p>{product.description}</p>
          </Tabs.Panel>

          <Tabs.Panel value="info" pt="xs">
            <table>
              <tr>
                <td>Weight</td>
                <td>
                  {product.additionalInfo && product.additionalInfo[0].weight}
                </td>
              </tr>
              <tr>
                <td>Harvest Date</td>
                <td>
                  {product.additionalInfo &&
                    new Date(
                      product.additionalInfo[0].HarvestDate
                    ).toDateString()}
                </td>
              </tr>
              <tr>
                <td>Sustainability Practice</td>
                <td>
                  {product.additionalInfo &&
                    product.additionalInfo[0].SustainabilityPractice}
                </td>
              </tr>
            </table>
          </Tabs.Panel>

          <Tabs.Panel value="reviews">
            <h2>
              {product.reviews && product.reviews.length} Review for{" "}
              {product.name}
            </h2>

            <div className="reviewWrapper">
              {product.reviews &&
                product.reviews.map((el) => {
                  return (
                    <div className="review">
                      <ReviewCard data={el} />
                    </div>
                  );
                })}
            </div>
            {/* <div className="addReview">
                        <h2>Add a review</h2>
                        <form action="">
                            <textarea name="" id="" cols="30" rows="5" placeholder="Your Review *"></textarea>
                            <div className="inputWrapper">
                                <input type="text" name="" id="" placeholder="Enter Name*" />
                                <input type="email" name="" id="" placeholder="Enter Email*"/>
                            </div>
                            <button>Submit Review</button>
                        </form>
                    </div> */}
          </Tabs.Panel>
        </Tabs>
      </section>

      <section className="relatedProducts">
        <div className="relatedProductHeading">
          <h2>Related Products</h2>
          <div className="directions">
            <AiOutlineLeft
              className={` review-swiper-button-prev prevButton btn`}
            />
            <AiOutlineRight
              className={` review-swiper-button-next nextButton btn`}
            />
          </div>
        </div>

        <Swiper
          cssMode={true}
          navigation={{
            nextEl: ".review-swiper-button-next",
            prevEl: ".review-swiper-button-prev",
          }}
          mousewheel={true}
          keyboard={true}
          spaceBetween={"2%"}
          breakpoints={{
            // when window width is >= 640px
            200: {
              slidesPerView: 1.5,
            },
            350: {
              slidesPerView: 1.5,
            },
            400: {
              slidesPerView: 2,
            },
            500: {
              slidesPerView: 2,
            },
            750: {
              slidesPerView: 3,
            },
            1000: {
              slidesPerView: 3.5,
            },
            // when window width is >= 768px
            1300: {
              slidesPerView: 4,
            },
          }}
          modules={[Navigation, Pagination, Mousewheel, Keyboard, FreeMode]}
          className="swiper"
        >
          {products.slice(0, 10).map((data) => {
            return (
              <SwiperSlide onClick={() => navigate(`/product/${data.id}`)}>
                <ProductCard
                  img={data.images[0].url}
                  name={data.name}
                  prevPrice={data.originalPrice}
                  price={data.discountPrice}
                  rating={data.ratings}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </section>

      <ServiceCard />
      <Footer />
    </>
  );
};

export default ProductDetails;
